import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Box,
  Stack,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { SIGNALS, inputSx, selectSx, TV } from '../../constants';

const SimultaneousSignalsDetails = ({ sub, idx, onUpdate }) => {
  const [signalInput, setSignalInput] = useState('');

  const signals = sub.condition?.signals || [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography sx={{ fontSize: '11px', color: TV.accent.primary, fontWeight: 600, mb: 1.5, textTransform: 'uppercase' }}>
          Signals
        </Typography>
      </Grid>

      {signals.map((sig, sigIdx) => (
        <Grid item xs={12} key={sigIdx}>
          <Stack direction="row" spacing={1} alignItems="center">
            <FormControl fullWidth size="small">
              <InputLabel>Signal</InputLabel>
              <Select 
                value={typeof sig === 'string' ? sig : sig.name || ''} 
                label="Signal"
                onChange={(e) => {
                  const updated = [...signals];
                  updated[sigIdx] = e.target.value;
                  onUpdate(idx, 'condition', { ...sub.condition, signals: updated });
                }}
                sx={selectSx}
              >
                <MenuItem value="">-- Select --</MenuItem>
                {SIGNALS.map(signal => <MenuItem key={signal} value={signal}>{signal}</MenuItem>)}
              </Select>
            </FormControl>
            <Button 
              size="small" 
              onClick={() => {
                const updated = signals.filter((_, i) => i !== sigIdx);
                onUpdate(idx, 'condition', { ...sub.condition, signals: updated });
              }}
              sx={{ color: TV.accent.danger, minWidth: '32px', p: 1 }}
            >
              <DeleteIcon sx={{ fontSize: '16px' }} />
            </Button>
          </Stack>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Stack direction="row" spacing={1} alignItems="center">
          <FormControl fullWidth size="small">
            <InputLabel>Signal</InputLabel>
            <Select 
              value={signalInput} 
              label="Signal"
              onChange={(e) => setSignalInput(e.target.value)}
              sx={selectSx}
            >
              <MenuItem value="">-- Select --</MenuItem>
              {SIGNALS.map(signal => <MenuItem key={signal} value={signal}>{signal}</MenuItem>)}
            </Select>
          </FormControl>
          <Button 
            size="small" 
            onClick={() => {
              if (signalInput.trim()) {
                onUpdate(idx, 'condition', { 
                  ...sub.condition, 
                  signals: [...signals, signalInput] 
                });
                setSignalInput('');
              }
            }}
            sx={{ color: TV.accent.primary, fontWeight: 600 }}
          >
            <AddIcon sx={{ fontSize: '16px' }} />
          </Button>
        </Stack>
      </Grid>

      <Grid item xs={12}><Box sx={{ height: '1px', bgcolor: TV.border.primary }} /></Grid>

      <Grid item xs={12} sm={6}>
        <TextField 
          fullWidth size="small" type="number" 
          label="Time Tolerance (ms)" 
          value={sub.condition?.time_tolerance_ms ?? 1000} 
          onChange={(e) => {
            const value = Math.max(0, parseInt(e.target.value) || 0);
            onUpdate(idx, 'condition', { ...sub.condition, time_tolerance_ms: value });
          }} 
          sx={inputSx} 
          inputProps={{ min: 0, step: 100 }}
          helperText="Max milliseconds between signals"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={sub.condition?.order_matters ?? false}
              onChange={(e) => onUpdate(idx, 'condition', { ...sub.condition, order_matters: e.target.checked })}
              sx={{ color: TV.accent.primary, '&.Mui-checked': { color: TV.accent.primary } }}
            />
          }
          label={<Typography sx={{ fontSize: '12px', color: TV.text.primary }}>Order Matters</Typography>}
        />
      </Grid>
    </Grid>
  );
};

export default SimultaneousSignalsDetails;
